<template>
  <div id="more_themeList">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="!isShowAnalysisFlag && renderThemeList"
    />
    <div
      class="themeItem_container"
      v-for="item in renderThemeList"
      :key="item.analysisItemId"
      :class="
        width100ThemeGraphicsIds.includes(item.graphicsId)
          ? width100ThemeGraphicsIdsClassName[
              width100ThemeGraphicsIds.indexOf(item.graphicsId)
            ]
          : ''
      "
    >
      <selectThemeContainer
        :currThemeObj="currThemeObj"
        :themeItem="item"
        :width100ThemeGraphicsIds="width100ThemeGraphicsIds"
        :width100ThemeGraphicsIdsClassName="width100ThemeGraphicsIdsClassName"
        @changeSelectToThemeItemEvent="changeSelectToThemeItem"
        @inFilterChangeEvent="changeSelectToThemeItemHandler"
      ></selectThemeContainer>
    </div>
  </div>
</template>

<script>
/*
 * @Author: wzc
 * @Date: 2024-04-17
 * @LastEditors: wzc
 * 超赛平台 类似赛果多个主题列表 且主题带选择框
 * @LastEditTime: 2023-04-17
 * 备注：主要应于 类似于赛果中的【数据分析】主题list；多个主题
 * 【足球世界杯：赛果（未同步）】
 * 【综合性赛事：赛果|小项数据分析】
 * 【CBA：赛果（未同步）】
 * 【羽毛球：赛果|晋级之路】
 */
// 该组件主要对应 more_findAnalysisItem_data.js 文件
import more_findAnalysisItem_data_mixin from '@mixins/more_findAnalysisItem_data'
import cup_base_data_mixin from '@mixins/cup_base_data'
import platfrom_refresh_data_mixin from '@mixins/platfrom_refresh_data'
import selectThemeContainer from '@components/platfromBase/compreSportsMeet/selectThemeContainer.vue'
import NOT_DATA from '@components/base/NO_DATA.vue'
export default {
  name: 'more_themeList',
  mixins: [
    cup_base_data_mixin,
    platfrom_refresh_data_mixin,
    more_findAnalysisItem_data_mixin,
  ],
  components: {
    NOT_DATA,
    selectThemeContainer,
  },
  props: {
    findAnalysisItemParams: {
      // more_findAnalysisItem_data_mixin 里面直接取这个值用，获取主题分析项时用到的参数，并且在主题中获取数据|主题上面的选择下拉框中用的参数都这个值里面的
      type: Object,
      default: () => {
        // return {
        //   templateType: this.themeTemplateType,
        //   cid: this.currCid,
        //   sid: this.currSid,
        //   did: 0,
        //   eid: 0,
        //   pid: 0,
        //   mid: this.mid,
        // }
        return {}
      },
    },
    paramsChangeObj: {
      // 这个根据当前页面逻辑，可用可不用，这个是当主题参数改变是重新刷新数据，跟定时更新数据不一样
      type: Object,
      default: () => {
        return {
          type: '',
          num: 0,
        }
      },
    },
  },
  data() {
    return {
      paramsChangeType: '', // ['reset'(主题个数不变，但是主题的数据要变，变数据时主题不会消失), 'clear'(主题的个数可能会变，renderThemeList=null，相当于重新初始化组件，变数据时主题会消失)]
      width100ThemeGraphicsIds: [3027, 3029, 4004],
      width100ThemeGraphicsIdsClassName: [
        'width100 height31vw mtb1388', //3027(复杂表格 比如【混合团体10米气手枪资格赛】)
        'width100 mtb1388', //3029(综合性赛事 对抗类 中网 表格 晋级之路)
        'width100', //4004(羽毛球【汤尤杯】运动员对阵)
      ],
    }
  },
  created() {
    this.init()
  },
  watch: {
    paramsChangeObj: {
      handler(newVal, oldVal) {
        console.debug('主题参数改变，重新加载数据:', newVal, oldVal)
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.paramsChangeType = newVal.type
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  methods: {
    init() {
      this.getMoreThemeDatas()
    },
    getMoreThemeDatas() {
      if (this.initMoreFindAnalysisItem) {
        // 走获取主题流程逻辑
        if (this.paramsChangeType === 'clear') {
          this.renderThemeList = null
        }
        this.initMoreFindAnalysisItem()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#more_themeList {
  padding: 1.388vw 0;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  .themeItem_container {
    padding-bottom: 1.388vw;
    width: calc((100% - 1.389vw) / 2);
    &.width100 {
      width: 100%;
    }
  }
}

/* .mixtmt_pc #more_themeList {
    .themeItem_container {
      &:hover {
        cursor: pointer;
      }
    }
  } */
</style>
